import { ErrorBoundary } from './components/ErrorBoundary';
import { Routes } from './Routes';
import TermlyScript from './components/TermlyScript';
import ConsentAwareAnalytics from './components/ConsentAwareAnalytics';
import { AcquisitionAttachment } from './components/AcquisitionAttachment';
import { Box } from '@mui/material';
import { PublicRouteHead } from './seo/PublicRouteHead';
import './components/beat-library/beatLibrary.css';

function App() {
  return (
    <ErrorBoundary>
      <PublicRouteHead />
      <TermlyScript />
      <ConsentAwareAnalytics />
      <AcquisitionAttachment />
      <Box
        sx={{
          // Page fade/slide transition for route changes
          animation: 'pageFadeIn 220ms ease-out',
          '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
          }
        }}
      >
        <Routes />
      </Box>
    </ErrorBoundary>
  );
}

export default App;
